import type { Pwf } from "../api/pwf";

export interface ProjectRef {
  id: string;
  title: string;
  spaceId: string | null;
  spaceName: string | null;
  isJourney: boolean;
}

/** Every life project / journey a takeaway can be rooted to via pwfMeta.fiPwf:
 *  top-level, non-template pwfs carrying config.lifeProject or
 *  config.studio.isJourney — regardless of lifecycle, since a finished
 *  project's steps and insights still belong to it. */
export function buildProjectIndex(pwfs: Pwf[]): Record<string, ProjectRef> {
  const index: Record<string, ProjectRef> = {};
  for (const p of pwfs ?? []) {
    if (p.isTemplate || p.pwfMeta?.fiParent) continue;
    const cfg = ((p.config ?? {}) as Record<string, any>);
    const lp = cfg.lifeProject as { spaceId?: string; spaceName?: string } | undefined;
    const isJourney = Boolean(cfg.studio?.isJourney);
    if (!lp && !isJourney) continue;
    index[p._id] = {
      id: p._id,
      title: p.title,
      spaceId: lp?.spaceId ?? null,
      spaceName: lp?.spaceName ?? null,
      isJourney,
    };
  }
  return index;
}

/** The project a takeaway was planted in, or null. Synthetic journey steps
 *  (`__isPwf`) are skipped — they already show their journey through
 *  source.engagementName. */
export function projectOf(
  index: Record<string, ProjectRef>,
  item: { pwfMeta?: { fiPwf?: string | null } | null; __isPwf?: boolean }
): ProjectRef | null {
  if (item.__isPwf) return null;
  const id = item.pwfMeta?.fiPwf;
  return id ? index[id] ?? null : null;
}
